import TokenService from '../../services/TokenService'

const getters = {
    token: () => {
        return TokenService.getToken()
    },
    user(){
        var base64Url = TokenService.getToken().split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
}

const mutations = {
    SET_TOKEN(state, token) {
        TokenService.saveToken(token);

        state.authenticating = true;
        state.authenticationError = '';
        state.authenticationErrorCode = 0
    }
}

export default {
    namespaced: true,
    getters,
    mutations
}